import {
  AnalyticsIcon,
  ApiIcon,
  CircleCIIcon,
  CodaIcon,
  ElasticIcon,
  GoogleDriveIcon,
  LightbulbIcon,
  NpmIcon,
  PackageIcon,
  RocketIcon,
  RubyGemsIcon,
  SlackIcon,
  SourcegraphIcon,
  StylesheetIcon,
} from '@appfolio/backstage-components';
import CategoryIcon from '@material-ui/icons/Category';
import CodeIcon from '@material-ui/icons/Code';
import DocsIcon from '@material-ui/icons/LibraryBooks';
import GitHubIcon from '@material-ui/icons/GitHub';
import WidgetsIcon from '@material-ui/icons/Widgets';

export default {
  analytics: AnalyticsIcon,
  api: ApiIcon,
  circleci: CircleCIIcon,
  coda: CodaIcon,
  code: CodeIcon,
  css: StylesheetIcon,
  docs: DocsIcon,
  github: GitHubIcon,
  'google-drive': GoogleDriveIcon,
  elastic: ElasticIcon,
  'kind:domain': CategoryIcon,
  'kind:resource': WidgetsIcon,
  idea: LightbulbIcon,
  npm: NpmIcon,
  package: PackageIcon,
  rocket: RocketIcon,
  rubygems: RubyGemsIcon,
  slack: SlackIcon,
  sourcegraph: SourcegraphIcon,
};
